module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Semibold.047d7c3.eot";